import { TranslocoService } from '@jsverse/transloco';
import { Map, NavigationControl, NavigationControlOptions } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';

const NAVIGATION_TOOLTIP_BY_SELECTOR = [
    ['.maplibregl-ctrl-zoom-in', 'mapControl.zoomIn'],
    ['.maplibregl-ctrl-zoom-out', 'mapControl.zoomOut'],
    ['.maplibregl-ctrl-compass', 'mapControl.resetNorth'],
];

export class NavigationControlExtended extends AbstractMapControl {
    private container: HTMLElement | null = null;
    private readonly navigationControl: NavigationControl;

    public constructor(
        private readonly translocoService: TranslocoService,
        options?: NavigationControlOptions,
    ) {
        super();
        this.navigationControl = new NavigationControl(options);
    }

    public override onAdd(map: Map): HTMLElement {
        this.map = map;
        this.container = this.navigationControl.onAdd(map);

        requestAnimationFrame(() => {
            if (!this.container) {
                return;
            }

            this.nativeButtonsStyle(this.container);
            this.refreshTooltips();
        });

        return this.container;
    }

    public override onRemove(): void {
        this.navigationControl.onRemove();
        this.container = null;
        this.map = undefined;
    }

    protected initButton(): void {}

    private refreshTooltips(): void {
        if (!this.container) {
            return;
        }

        for (const [selector, translationKey] of NAVIGATION_TOOLTIP_BY_SELECTOR) {
            const button = this.container.querySelector<HTMLButtonElement>(selector);
            if (!button) {
                continue;
            }

            button.title = this.translocoService.translate(translationKey);
        }
    }
}
